import dashboard from "./dashboard.vue";
/**
 * fore color and back color
 * Created by peak on 16/8/18.
 */
export default {
    name: "color",
    icon: "custom-icon color",
    i18n: "color",
    show: true,
    dashboard
}



// WEBPACK FOOTER //
// ./src/components/editor/src/modules/color/index.js